

import { MultiValueProps } from 'react-select/src/components/MultiValue';
import { MultiValueWrapper } from '../styles';
import { BTag } from '../../../../core/components';

export const MultiValue = (props: MultiValueProps<any>) => {
    return (
        <MultiValueWrapper>
            <BTag removable onClick={props.removeProps.onClick}>
                {props.children}
            </BTag>
        </MultiValueWrapper>
    );
};


import { MultiValueProps } from 'react-select/src/components/MultiValue';
import { MultiValueWrapper } from '../styles';
import { BTag } from '../../../../core/components';

export const MultiValue = (props: MultiValueProps<any>) => {
    return (
        <MultiValueWrapper>
            <BTag removable onClick={props.removeProps.onClick}>
                {props.children}
            </BTag>
        </MultiValueWrapper>
    );
};
